// 画像アップロードが失敗するケースの判定と、失敗時のユーザー向け文言。
// infrastructure/api.ts を import しない（vitest の '@' alias は operations SPA を指すため、
// reactSrc 側のテスト対象モジュールでは '@' 経由の import を避ける）ので、
// ApiError は instanceof ではなく body の形で判定する。

export const IMAGE_UPLOAD_FAILED_MESSAGE =
  '画像のアップロードに失敗しました。時間をおいて再度お試しください。';

export const IMAGE_DELETE_FAILED_MESSAGE =
  '画像の削除に失敗しました。時間をおいて再度お試しください。';

export const FILE_READ_FAILED_MESSAGE =
  'ファイルの読み込みに失敗しました。別の画像で再度お試しください。';

export const MAX_IMAGE_FILE_SIZE_MB = 20;

export const MAX_IMAGE_FILE_SIZE_MESSAGE =
  `${MAX_IMAGE_FILE_SIZE_MB}MBを超えるファイルはアップロードできません。` as const;

// 画面表記は「${MAX_IMAGE_FILE_SIZE_MB}MB以下」なので、ちょうど上限のファイルは許可する
export const isFileSizeExceeded = (file: File): boolean =>
  file.size > MAX_IMAGE_FILE_SIZE_MB * 1024 * 1024;

const hasBody = (error: unknown): error is { body: unknown } =>
  typeof error === 'object' && error !== null && 'body' in error;

// サーバーが 422 で返す `["エラーメッセージ"]`（api_partner/recreation_images_controller.rb の
// `render_json([e.message], status: 422)`）はそのまま表示し、それ以外
// （Heroku のリクエストタイムアウト由来の 503、ネットワーク断など）は fallback を表示する。
export const fileApiErrorMessages = (
  error: unknown,
  fallbackMessage: string
): Array<string> => {
  const body = hasBody(error) ? error.body : undefined;
  if (
    Array.isArray(body) &&
    body.length > 0 &&
    body.every(
      (message): message is string =>
        typeof message === 'string' && message.length > 0
    )
  ) {
    return body;
  }
  return [fallbackMessage];
};
